import { Inject, Injectable } from '@angular/core';

import Env from '@ridango/core/env';
import { ShoppingCartIconService } from '../../shopping-cart/shopping-cart-icon.service';
import { PaymentDataService } from '@ridango/core';
import { ProductActivationMethod } from '../../purchase/purchase.model';

type JourneyRepurchaseActivation = Pick<ProductActivationMethod, 'activationTrigger'> &
    Partial<ProductActivationMethod>;

export interface JourneyRepurchaseData {
    productId?: string | number;
    productParametersCode?: string;
    dynamicProductParameters?: Record<string, any>;
    startZoneId?: number;
    endZoneId?: number;
    activations?: JourneyRepurchaseActivation[];
}

@Injectable({ providedIn: 'root' })
export class SessionService {
    constructor(
        @Inject('ENV') private env: Env,
        private shoppingCartIconService: ShoppingCartIconService,
        private paymentData: PaymentDataService
    ) {}

    setLocalAccessToken(data: any, isCorporate = false) {
        localStorage.setItem(`${this.env.APP_NAME}-access`, data.token);
        if (data.email) {
            localStorage.setItem(`${this.env.APP_NAME}-access-user-email`, data.email);
        }

        if (!isCorporate || !this.getLoggedInUserName()) {
            if (data.email) {
                localStorage.setItem(`${this.env.APP_NAME}-access-user`, data.email);
            }
            if (data.name) {
                localStorage.setItem(`${this.env.APP_NAME}-access-user`, data.name);
            }
            return;
        }
    }

    getLocalAccessToken(): string {
        return localStorage.getItem(`${this.env.APP_NAME}-access`);
    }

    setLoggedInUserName(name: string) {
        localStorage.setItem(`${this.env.APP_NAME}-access-user`, name);
    }

    getLoggedInUserName() {
        return localStorage.getItem(`${this.env.APP_NAME}-access-user`);
    }

    getLoggedInEmail() {
        return localStorage.getItem(`${this.env.APP_NAME}-access-user-email`);
    }

    getLoginStatus() {
        if (localStorage.getItem(`${this.env.APP_NAME}-access`)) {
            return true;
        }
        return false;
    }

    signOut() {
        this.paymentData.resetData();
        if (this.env.ENABLE_PURCHASE_V2) {
            this.shoppingCartIconService.initializeHeaderShoppingCart(0, null);
        }
        localStorage.removeItem(`${this.env.APP_NAME}-cart-id`);
        localStorage.removeItem(`${this.env.APP_NAME}-access`);
        localStorage.removeItem(`${this.env.APP_NAME}-access-user`);
        localStorage.removeItem(`${this.env.APP_NAME}-access-user-email`);
        localStorage.removeItem(`${this.env.APP_NAME}-account-personalized`);
    }

    setJourneyQueryParams(params: string) {
        sessionStorage.setItem('JOURNEY_PARAMS', params);
    }

    getJourneyQueryParams(): string {
        return sessionStorage.getItem('JOURNEY_PARAMS');
    }

    removeJourneyQueryParams() {
        sessionStorage.removeItem('JOURNEY_PARAMS');
    }

    setJourneyRepurchaseData(data: JourneyRepurchaseData) {
        sessionStorage.setItem('JOURNEY_REPURCHASE_DATA', JSON.stringify(data));
    }

    getJourneyRepurchaseData(): JourneyRepurchaseData | null {
        const data = sessionStorage.getItem('JOURNEY_REPURCHASE_DATA');
        if (!data) {
            return null;
        }

        try {
            return JSON.parse(data);
        } catch (e) {
            return null;
        }
    }

    removeJourneyRepurchaseData() {
        sessionStorage.removeItem('JOURNEY_REPURCHASE_DATA');
    }
}
